import { render, staticRenderFns } from "./CustomerSms.vue?vue&type=template&id=2839ced6&scoped=true"
import script from "./CustomerSms.vue?vue&type=script&lang=js"
export * from "./CustomerSms.vue?vue&type=script&lang=js"
import style0 from "./CustomerSms.vue?vue&type=style&index=0&id=2839ced6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839ced6",
  null
  
)

export default component.exports